<template>
<div class="chapter">
<div class="inner_page">
<div class="Basic-Text-Frame">
<p class="content-t" id="calibre_toc_1"><span class="char-style-override1">Your<br class="calibre3"/></span>Next<br class="calibre1"/>Level<br class="calibre1"/><span class="char-style-override1">Life</span></p>
<p class="Basic-Paragraph"> </p>
<p class="Basic-Paragraph1">7 Rules of Power, Confidence, and <br class="calibre3"/>Opportunity for Black Women in America</p>
<p class="Basic-Paragraph1"> </p>
<p class="Basic-Paragraph2"><span class="char-style-override2">KAREN ARRINGTON <br class="calibre1"/></span><span class="char-style-override3"> </span></p>
<p class="Basic-Paragraph3"> </p>
<p class="Normal"><span class="char-style-override4"><span><img alt="5110.png" src="OEBPS/image/5110.png"/></span><br class="calibre3"/></span><span class="Italics">Mango Publishing<br class="calibre3"/></span><span class="char-style-override5">Coral Gables</span></p>
<div class="calibre2" id="calibre_pb_1"></div>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// YourNextLevelLife_split_001.vue?e48401ee